import React, { FC } from 'react';
import { Button, Grid } from '@material-ui/core';
import { useFormikContext } from 'formik';

import { Loaders } from 'components';
import { ContentInput } from 'api';
import { PostSchema } from '../../posting/validations';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router';

const useStyles = makeStyles(theme => ({
  button: {
    borderRadius: '4px',
    marginLeft: theme.spacing(2),
  },
}));

const FormButtons: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const history = useHistory();
  const { values, isValid, isSubmitting } = useFormikContext<ContentInput>();

  const valid = isValid && PostSchema.isValidSync(values);

  if (isSubmitting) {
    return (
      <Grid container justify="flex-end">
        <Grid item>
          <Loaders.Standard height={30} />
        </Grid>
        <Grid item />
      </Grid>
    );
  }

  return (
    <Grid item xs container justify="flex-end">
      <Grid item>
        <Button
          className={classes.button}
          color="primary"
          variant="outlined"
          size="large"
          onClick={() => history.goBack()}>
          {t('common:cancel')}
        </Button>
      </Grid>
      <Grid item>
        <Button
          className={classes.button}
          color="primary"
          variant="contained"
          size="large"
          type="submit"
          disabled={!valid}>
          {t('common:post')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default FormButtons;
